export enum CDNUrl {
    /*
      DO NOT change the following line
      this needs to be set to PRODUCTION environment's CDN
      we are working on making this environment specific
      until then, please tell QA to expect 404s for new images on wb-qa environment
      these 404s will be resolved once a production release is done
    */
    IMAGE_CDN = 'https://img.cdn.myworkboard.com/wb'
}
